import { Block, BlockProps, useStyletron } from "@mezo-org/mezo-clay"

export default function StakingItemContainer({
  children,
  ...props
}: BlockProps) {
  const [css, theme] = useStyletron()

  return (
    <Block
      className={css({
        display: "flex",
        justifyContent: "space-between",
        borderRadius: theme.sizing.scale500,
        background: theme.colors.backgroundSecondary,
        padding: theme.sizing.scale600,
      })}
      {...props}
    >
      {children}
    </Block>
  )
}
